import { useCallback } from 'react'
import {
  selectPackageName,
  selectProductPackages,
  useProductPackagesStore,
} from '@/stores/product-packages-store'

// 别名来自 GET /product-packages（见 components/product-packages-loader.jsx）。
// code 是查询参数，始终不变；以下函数只在展示层把 code 映射为别名。

/**
 * 根据 package code 获取对应的别名（非响应式；渲染期请用 usePackageNameGetter）
 * @param {string} code - Package code
 * @returns {string} - 别名，如果找不到则返回原 code
 */
export const getPackageName = (code) =>
  selectPackageName(useProductPackagesStore.getState(), code)

export const hasProductPackages = (pid) => ['14', '36'].includes(String(pid))

/** 非响应式；渲染期请用 useProductPackages。未加载时返回 [] */
export const getProductPackages = (pid) =>
  selectProductPackages(useProductPackagesStore.getState(), pid)

/** 列表未加载时原样返回，避免首屏 URL 同步把 packageName 清空 */
export const normalizePackageSelection = (pid, value) => {
  if (!useProductPackagesStore.getState().loaded) return value
  return getProductPackages(pid).some((item) => item.code === value)
    ? value
    : ''
}

/** 订阅 store：子包列表加载或改名后组件会重渲染 */
export const useProductPackages = (pid) =>
  useProductPackagesStore((state) => selectProductPackages(state, pid))

export const useProductPackagesLoaded = () =>
  useProductPackagesStore((state) => state.loaded)

/** 订阅 store：返回随别名更新而变化的 code → 别名 函数 */
export const usePackageNameGetter = () => {
  const names = useProductPackagesStore((state) => state.names)
  return useCallback((code) => selectPackageName({ names }, code), [names])
}
